import PropTypes from "prop-types";
import { useState, useEffect } from 'react';
import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';
import Preloader from '../../components/Preloader';

const containerStyle = {
  width: '100%',
  height: '400px',
};

const UbicacionVentaConsult = ({ form }) => {
  const [ubicacion, setUbicacion] = useState(null);
  const [marcador, setMarcador] = useState(null);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });

  useEffect(() => {
    if (form.latitud && form.longitud) {
      const lat = Number(form.latitud);
      const lng = Number(form.longitud);
      const coords = { lat, lng };
      setUbicacion(coords);
      setMarcador(coords);
    }
  }, [form.latitud, form.longitud]);

  if (loadError) return <div>Error cargando el mapa</div>;
  if (!isLoaded) return <Preloader />;

  // Mostrar mensaje si no hay latitud o longitud
  if (!form.latitud || !form.longitud) {
    return <div>No tiene ubicación registrada</div>;
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={ubicacion}
      zoom={15}
      options={{ clickableIcons: false, disableDefaultUI: true }}
    >
      {marcador && <MarkerF position={marcador} />}
    </GoogleMap>
  );
};

UbicacionVentaConsult.propTypes = {
  form: PropTypes.object.isRequired,
};

export default UbicacionVentaConsult;
